var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-modal',{attrs:{"name":_vm.name,"adaptive":true,"clickToClose":_vm.clickToClose,"height":"auto"},on:{"closed":function($event){return _vm.$emit('input', false)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }